import { Row, Col, Form, Button, Table } from "react-bootstrap";
import { useState } from "react";
import React from "react";
import { ModalMessage } from "..";

function AttributesForm(props) {
  // form for managing attributes, allowing users to add, delete, and view existing attributes
  // user can add a new (custom attribute), or choose to add/edit from a list of existing attributes

  const [attrError, setAttrError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [editingCustomAttr, setEditingCustomAttr] = useState(false); //expand field to let user enter own attr
  const [currCustomAttr, setCurrCustomAttr] = useState({ name: "", value: "" });
  const [currAttr, setCurrAttr] = useState({ name: "", _id: "" });

  const handleAddAttribute = () => {
    // update the attribute state variable
    // only allow if name + value are filled out
    // custom (i.e. new) attribute
    if (currCustomAttr?.value && currCustomAttr.name) {
      //format to lower case, no whitespace, -> 'name:value'
      const formattedAttribute =
        currCustomAttr.name.trim().toLowerCase() +
        ":" +
        currCustomAttr.value.trim().toLowerCase();
      if (
        props.newCustomAttributes.some(
          (obj) => obj.name === formattedAttribute
        ) ||
        props.attributes.some((obj) => obj.name === formattedAttribute)
      ) {
        setErrorMsg("An attribute with this value already exists.");
      } else {
        props.setNewCustomAttributes([
          ...props.newCustomAttributes,
          { name: formattedAttribute },
        ]);
      }
      setEditingCustomAttr(false);
      setCurrCustomAttr({ name: "" });
    } else if (currAttr?.name && currAttr?._id) {
      // add to attributes
      if (
        props.newCustomAttributes.some((obj) => obj.name === currAttr.name) ||
        props.attributes.some((obj) => obj._id === currAttr._id)
      ) {
        setErrorMsg("An attribute with this value already exists.");
      } else {
        props.setAttributes([...props.attributes, currAttr]);
      }
    } else {
      //
      setAttrError(true);
    }
  };

  const handleDeleteAttr = (attr) => {
    // delete from state variable
    if (!attr?._id) {
      //delete from newCustomAttributes
      props.setNewCustomAttributes(
        props.newCustomAttributes.filter(
          (customAttr) => customAttr.name !== attr.name
        )
      );
    } else {
      //delete from attributes
      props.setAttributes(
        props.attributes.filter((attribute) => attribute?._id !== attr?._id)
      );
    }
  };
  return (
    <>
      {errorMsg && (
        <ModalMessage
          type="danger"
          message={errorMsg}
          setErrorMsg={setErrorMsg}
        />
      )}
      <Row className="align-items-center mt-3">
        <Col xs={5}>
          <Form.Label>Name</Form.Label>
          {"\u00A0"}
          <Button
            className="btn-sm"
            variant="outline-secondary"
            onClick={() => setEditingCustomAttr(!editingCustomAttr)}
            style={{ padding: "2px 8px", borderRadius: "50px" }}
          >
            <i className="bi bi-plus-lg"></i>{" "}
            {editingCustomAttr ? "Cancel" : "New"}
          </Button>
          {editingCustomAttr ? (
            <Form.Control
              name="newAttrName"
              type="text"
              placeholder="Add custom name"
              value={currCustomAttr.name}
              onChange={(event) => {
                setCurrCustomAttr({
                  ...currCustomAttr,
                  name: event.target.value,
                });
              }}
              isInvalid={attrError}
            />
          ) : (
            <Form.Select
              name="newAttrName"
              value={currAttr?._id}
              onChange={(event) => {
                const attrObject = props.availableAttributes.find(
                  (attr) => attr?._id === event.target.value
                );

                setCurrAttr(attrObject);
              }}
              isInvalid={attrError}
            >
              <option value="">Choose an attribute</option>
              {props?.availableAttributes &&
                props.availableAttributes.length > 0 &&
                props.availableAttributes.map((attr, idx) => {
                  return (
                    <option key={attr?._id} value={attr?._id}>
                      {attr.name}
                    </option>
                  );
                })}
            </Form.Select>
          )}
        </Col>
        {editingCustomAttr && (
          <Col xs={5}>
            <>
              <Form.Label>Value</Form.Label>
              {"\u00A0"}
              <Form.Control
                name="newAttrValue"
                type="text"
                placeholder="Add custom value"
                value={currCustomAttr.value}
                onChange={(event) => {
                  setCurrCustomAttr({
                    ...currCustomAttr,
                    value: event.target.value,
                  });
                }}
                isInvalid={attrError}
              />
            </>
          </Col>
        )}

        <Col xs={2}>
          <Button
            variant="outline-primary"
            style={{ marginTop: "33px" }}
            type="button"
            onClick={() => handleAddAttribute()}
          >
            Add
          </Button>
        </Col>
        {attrError && (
          <div style={{ color: "red", fontSize: "small" }}>
            Please choose an attribute from the list, or enter both the name and
            value.
          </div>
        )}
      </Row>

      <Col>
        {/* ALREADY ADDED ATTRIBUTES */}
        {((props.attributes && props.attributes.length > 0) ||
          (props.newCustomAttributes &&
            props.newCustomAttributes.length > 0)) && (
          <Table
            style={{
              color: "gray",
              backgroundColor: "#fafafa",
              borderRadius: "5px",
            }}
            // bordered
            hover
            size="sm"
            className="mt-3 my-table"
          >
            <thead>
              <tr>
                <th colSpan="3"> Current attributes</th>
              </tr>
            </thead>
            <tbody>
              {props.attributes.map((attribute, idx) => {
                return (
                  <tr key={attribute._id+"existing"}>
                    <td>{attribute.name}</td>
                    <td
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        className="btn-sm "
                        variant="outline-danger"
                        onClick={(event) => {
                          handleDeleteAttr(attribute);
                        }}
                      >
                        <i className="bi bi-trash3-fill"></i>
                      </Button>
                    </td>
                  </tr>
                );
              })}
              {props.newCustomAttributes.map((attribute, idx) => {
                return (
                  <tr key={attribute._id+"custom"}>
                    <td>{attribute.name}</td>
                    <td
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        className="btn-sm "
                        variant="outline-danger"
                        onClick={(event) => handleDeleteAttr(attribute)}
                      >
                        <i className="bi bi-trash3-fill"></i>
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </Col>
    </>
  );
}

export default React.memo(AttributesForm); //component will only rerender if its own props change, not every time parent rerenders
